import React from "react";
import PropTypes from "prop-types";
import TableDataSpinner from "../../../../app/components/modals/employee/DeleteEmployeesModal/components/TableDataSpinner";
import MovementsContent from "../MovementsContent";

const MovementsTable = ({ movements, isLoading }) => {
  return isLoading ? (
    <TableDataSpinner />
  ) : (
    <>
      <MovementsContent movements={movements} />
    </>
  );
};

MovementsTable.defaultProps = {
  isLoading: false,
};

MovementsTable.propTypes = {
  movements: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
};

export default MovementsTable;
